import { Button, Container, IconButton } from "@mui/material";
import { ImageCheck, LoadingSimpleComponent } from "Explore/Components";
import { IconPack } from "Explore/Config/Icons";
import { ImageCheckType, SkeletonType } from "Explore/Config/ImageType";
import { Modal } from "antd";
import { useState } from "react";
import styles from "./BasicInformation.module.scss";

const BasicInformation = ({ summary }) => {
  const [seeMore, setSeeMore] = useState(false);
  return (
    <>
      <div className={styles["container"]}>
        <Container maxWidth="lg" className={styles["basic-information"]}>
          <div className={styles["basic-information__left"]}>
            <LoadingSimpleComponent
              component={
                <ImageCheck
                  url={summary?.data.photo}
                  className={styles["logo"]}
                  alt={"logo"}
                  type={ImageCheckType.INSTITUTION_LOGO}
                />
              }
              type={SkeletonType.INPUT}
              isLoading={summary.isLoading}
              className={styles["logo-wrapper"]}
            />
          </div>
          <div className={styles["basic-information__right"]}>
            <LoadingSimpleComponent
              component={
                <h1 className={styles["name"]} style={{ textAlign: "center" }}>{summary?.data.name}</h1>
              }
              type={SkeletonType.INPUT}
              isLoading={summary.isLoading}
              className={styles["name"]}
            />
            <LoadingSimpleComponent
              component={
                <p className={styles["bio"]} onClick={() => setSeeMore(true)}>
                  {summary.data?.biography}
                </p>
              }
              type={SkeletonType.PARAGRAPH}
              isLoading={summary.isLoading}
            />
            <div className={styles["more-info"]}>
              <Button
                className={`${styles["more-info--item"]}`}
                href={summary?.data?.official_web}
                target="_blank" rel="noreferrer"
              >
                <div className={styles["more-info--item--start-icon"]}>
                  {IconPack.global_outlined}
                </div>
                Official web
                <div className={styles["more-info--item--link-icon"]}>
                  {IconPack.externalLink}
                </div>
              </Button>
              {!!summary?.data?.wikipedia && (
                <Button
                  className={`${styles["more-info--item"]}`}
                  href={summary?.data?.wikipedia}
                  target="_blank" rel="noreferrer"
                >
                  Wikipedia
                  <div className={styles["more-info--item--link-icon"]}>
                    {IconPack.externalLink}
                  </div>
                </Button>
              )}
            </div>
          </div>
        </Container>
      </div>

      <Modal
        title="Biography"
        placement={"bottom"}
        onCancel={() => setSeeMore(false)}
        open={seeMore}
        footer={null}
      >
        <p>{summary.data?.biography}</p>
      </Modal>
    </>
  );
};

export default BasicInformation;
